import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { fetchCategory, fetchProducts } from "../lib/api";

const Category = () => {
  const { categoryId } = useParams();
  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchCategory(categoryId).catch(() => null),
      fetchProducts({ category: categoryId }).catch(() => []),
    ]).then(([cat, prods]) => {
      setCategory(cat);
      setProducts(prods);
      setLoading(false);
    });
  }, [categoryId]);

  if (loading) {
    return <main className="max-w-[1400px] mx-auto px-6 mt-16 min-h-[40vh]" />;
  }

  if (!category) {
    return (
      <main className="max-w-[1400px] mx-auto px-6 mt-16 min-h-[40vh]">
        <h1 className="font-serif-brand text-3xl text-[#0e2a1e]">Category not found</h1>
        <Link to="/shop" className="text-[#a4820e] mt-4 inline-block">Back to shop →</Link>
      </main>
    );
  }

  return (
    <main className="max-w-[1400px] mx-auto px-6 mt-10 fade-up">
      <h1 className="font-serif-brand text-4xl font-semibold text-[#0e2a1e]">{category.name}</h1>
      <p className="text-[#0e2a1e]/60 text-sm mt-2 mb-6">
        Browse subcollections below or explore everything in this department.
      </p>

      <div className="flex flex-wrap gap-3 mb-10">
        {(category.subcollections || []).map((s) => (
          <span
            key={s.id}
            className="px-4 py-2 rounded-full border border-[#0e2a1e]/20 text-sm text-[#0e2a1e] hover:bg-[#0e2a1e] hover:text-[#f4f2ea] transition-colors cursor-pointer"
          >
            {s.name}
          </span>
        ))}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {products.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </main>
  );
};

export default Category;
